module.exports = {"missingPermission":"Nous sommes désolés, vous n'avez pas accès à cette page pour le moment.","contactAdministration":"Veuillez contacter la personne qui gère l'administration de ce compte Trustpilot au sein de votre entreprise."}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/MissingPermission/localization/fr-FR/strings.json
// module id = 1229
// module chunks = 0